import { useState, useContext, useMemo } from 'react'
import { Typography, TextField, Button, Stack, Switch } from '@mui/material'
import { enqueueSnackbar } from 'notistack'

import { AppContext } from '/providers/app-context'
import { toggleScannerPassEnabled } from '/providers/studio-api'
import StyledPaper from '/components/paper'
import EditForm from '/components/passes/editor'

const PassEditormembership = ({ pass, template, setPass }) => {

  return (
    <div className='h-full'>
      <Typography variant="h6" sx={{ p: 2 }}>Membership Card Editor</Typography>
      <div className='overflow-y-scroll h-full pb-32'>
        <ManageTab pass={pass} templateId={template.id} setPass={setPass} />
      </div>
    </div>
  )
}

export default PassEditormembership



const ManageTab = ({ pass, templateId, setPass }) => {

  const { apiSource, apiKey, setProcessing } = useContext(AppContext)

  const [enabled, setEnabled] = useState(pass.scanner_instance_data["*_disabled"] === null)
  const [note, setNote] = useState("")

  const passCurrentlyEnabled = useMemo(() => pass.scanner_instance_data["*_disabled"] === null, [pass.scanner_instance_data["*_disabled"]])

  const noteDisabled = useMemo(() => enabled === passCurrentlyEnabled, [enabled, passCurrentlyEnabled])

  const saveEnabledDisabled = async () => {
    setProcessing(true)
    const result = await toggleScannerPassEnabled({ apiSource, apiKey, templateId, passId: pass.pass_id, enabled, note })
    setProcessing(false)

    if (result.error) {
      enqueueSnackbar({ message: result.error, variant: 'error' })
    } else {
      setPass(result)
      setNote("")
      enqueueSnackbar({ message: 'Ticket ' + (enabled ? "enabled" : "disabled"), variant: 'success' })
    }
  }

  return (
    <div className='flex flex-1 flex-col justify-around items-center'>
      <div className='flex flex-row justify-around items-start gap-10'>

        <div style={{ width: 800 }} className='flex flex-col gap-5'>
          <StyledPaper>
            <Typography variant='h4'>Pass (Instance) Data</Typography>
            <EditForm pass={pass} templateId={templateId} setPass={setPass} />
          </StyledPaper>
        </div>

        <div style={{ width: 800 }} className='flex flex-col gap-5'>
          <StyledPaper>
            <Typography variant='h4'>Scanner Data</Typography>
            <EditForm pass={pass} templateId={templateId} setPass={setPass} dataSource='scanner_instance_data' />
          </StyledPaper>

          <StyledPaper>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <Typography>Membership Card status: Disabled</Typography>
              <Switch checked={enabled} onChange={e => setEnabled(e.target.checked)} />
              <Typography>Enabled</Typography>
            </Stack>

            <TextField multiline fullWidth rows={4} label="Note" onChange={e => setNote(e.target.value)} disabled={noteDisabled} helperText={`Add a note to explain why you are ${passCurrentlyEnabled ? "disabling" : "enabling"} this membership card `} slotProps={{
              inputLabel: {
                shrink: true,
              }
            }}>{note}</TextField>

            <div className='self-end'>
              <Button variant='contained' disabled={note === ""} onClick={saveEnabledDisabled}>Save</Button>
            </div>
          </StyledPaper>
        </div>
      </div>
    </div>
  )
}